import { HStack } from '@ayble-health/dashboard-components';
import ReactSelect from 'react-select';

type Option = { label: string; value: string };

type Props = {
  setSelectedId: (val?: string) => void;
  selectedCoach?: string;
  selectedId?: string;
  coachOptions?: Option[];
  providerOptions?: Option[];
};

export const CareMemberFilter = ({
  setSelectedId,
  selectedId,
  coachOptions = [],
  providerOptions = [],
}: Props) => {
  const groupedOptions = [
    ...(coachOptions.length > 0
      ? [{ label: 'Coach', options: coachOptions }]
      : []),
    ...(providerOptions.length > 0
      ? [{ label: 'Provider', options: providerOptions }]
      : []),
  ];

  const selectedOption =
    [...coachOptions, ...providerOptions].find((o) => o.value === selectedId) ??
    null;

  return (
    <HStack gap={2} alignSelf={'flex-end'} ml={'auto'}>
      <ReactSelect
        options={groupedOptions}
        value={selectedOption}
        onChange={(option) => setSelectedId(option?.value)}
        placeholder="Select member"
        menuPlacement="bottom"
        menuPosition="fixed"
      />
    </HStack>
  );
};

export default CareMemberFilter;
